<div class="available">
  <data-table #dynamicContentTable (detail)="detail($event)" (remove)="remove($event)" (edit)="edit($event)" [newHeader]="true"
              title="Dynamic Content Entrances" [columns]="columns" [dataProvider]="assignedContentEntranceService" [searchAll]="true"
              [headerButtons]="headerButtons"></data-table>
</div>
